export const THEME = {
    colors: {
        primary: {
            DEFAULT: "#F59E0B", // amber-500
            hover: "#D97706", // amber-600
            light: "#FCD34D", // amber-300
        },
        background: {
            DEFAULT: "#18181B", // zinc-900
            card: "rgba(39, 39, 42, 0.3)", // zinc-800/30
            overlay: "rgba(24, 24, 27, 0.7)", // zinc-900/70
        },
        border: {
            DEFAULT: "rgba(63, 63, 70, 0.5)", // zinc-700/50
            hover: "rgba(245, 158, 11, 0.5)", // amber-500/50
        },
        text: {
            primary: "#F4F4F5", // zinc-100
            secondary: "#A1A1AA", // zinc-400
            muted: "#71717A", // zinc-500
        },
    },
    borderRadius: {
        sm: "0.25rem",
        md: "0.375rem",
        lg: "0.5rem",
    },
    boxShadow: {
        sm: "0 1px 2px rgba(0, 0, 0, 0.1)",
        md: "0 4px 6px rgba(0, 0, 0, 0.1)",
        lg: "0 10px 15px rgba(0, 0, 0, 0.1)",
    },
    animation: {
        duration: {
            fast: "200ms",
            default: "300ms",
            slow: "500ms",
        },
        timing: "cubic-bezier(0.4, 0, 0.2, 1)",
    },
    spacing: {
        container: "max-w-7xl",
        section: "mb-16",
    },
    shadows: {
        sm: "0 1px 2px rgba(0, 0, 0, 0.1)",
        DEFAULT: "0 4px 6px rgba(0, 0, 0, 0.1)",
        lg: "0 10px 15px rgba(0, 0, 0, 0.1)",
    },
};
